module.exports = __webpack_public_path__ + "static/media/3.6283bf77.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/3.png
// module id = 698
// module chunks = 0